<div *ngIf="displayProfileSearch === true">

    
    <div class="container-full">
      <div style="margin-left:20px;margin-right:20px;margin-top:20px;">
        <div class="row">
          <div class="col-12">
            
      <mat-accordion class="example-headers-align" multi>
        
          
            <mat-expansion-panel 
              [expanded]="displayQuickSearchRegion"
              (opened)="displayQuickSearchRegion = true"
              (closed)="displayQuickSearchRegion = false">
            <mat-expansion-panel-header #matExpansionPanel style="background-color: #003087;color:white;">
              <mat-panel-title>
                <span class="ace-heading-text-level-1" style="color:white;">Parker Profile</span>
              </mat-panel-title>
              <mat-panel-description>
                <span  class="ace-heading-text-level-1" style="color:white;">{{this._appGeneralState.currentLotNumber}} - {{this._appGeneralState.currentLotName}}</span>
              </mat-panel-description>
            </mat-expansion-panel-header>



    <form 
      (ngSubmit)="onSubmitParkerProfileQuery()" 
      novalidate
      [formGroup]="queryCriteriaForm" 
      style="margin-top:20px;">

      <div class="row">

         
        
          <div class="col-2">
          
              <button type="button" mat-mini-fab color="primary" aria-label="Add New Parker" (click)="onNavigateToAddParker()" style="margin-left:20px;" matTooltip="Add a new Parker">
                <mat-icon>control_point</mat-icon>
              </button>
          </div>
        
          <div class="col-2">
              <button type="button" mat-mini-fab color="primary" aria-label="Parker Import" (click)="onNavToParkerImport()" style="margin-left:20px;" matTooltip="Parker Import">
                <mat-icon>cloud_upload</mat-icon>
              </button>
          </div>
          <div class="col-2">
              <img src="../../../../assets/images/space-Logo-with-text.png" style="height:50px;position: relative;top:-3px;" class="logo-mouse-over mimic-button-hover" matTooltip="Sync spACE Accounts" (click)="OnNavParkerSpaceLinks()">
          </div>
        </div>
  
        <div class="row mt-3" style="width: 100%">
          <div class="col-6">
            <mat-form-field appearance="fill" style="width:100%;color:gray">
              <mat-label>Company:</mat-label>
              <mat-select formControlName="companyName" (selectionChange)="onCompanyNameChanged($event.value)" >
                <mat-option value="ALL">All Companies</mat-option>
                <mat-option *ngFor="let company of companyList" [value]="company.companyId" >
                 {{company.companyName}}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
  
          <div class="col-6">
            <mat-form-field appearance="fill" style="width:100%">
              <mat-label>Vehicle License Plate:</mat-label>
              <input matInput placeholder="Enter any part of license plate (minimum 3 characters required)" formControlName="vehicleLicensePlate" [errorStateMatcher]="showOnDirtyErrorStateMatcher">
              <!-- <mat-hint>Enter any part of license plate (minimum 3 characters required)</mat-hint> -->
              <mat-error *ngIf="queryCriteriaForm.get('vehicleLicensePlate')?.hasError('minlength') && (queryCriteriaForm.get('vehicleLicensePlate')?.dirty || queryCriteriaForm.get('vehicleLicensePlate')?.touched)">The vehicle license plate requires 3 or more characters before searching.</mat-error>
            </mat-form-field>
          </div>

          <div class="col-6" style="margin-top: 0px;">
            <mat-form-field appearance="fill" style="width:100%">
              <mat-label>Parker First Name:</mat-label>
              <input matInput placeholder="Parker Name" formControlName="firstName" >
            </mat-form-field>
          </div>
  
          <div class="col-6" style="margin-top: 0px;">
            <mat-form-field appearance="fill" style="width:100%">
              <mat-label>Parker Last Name:</mat-label>
              <input matInput placeholder="Parker Last Name"  formControlName="lastName">
            </mat-form-field>
          </div>

          <div class="col-6">
            <mat-form-field appearance="fill" style="width:100%">
              <mat-label>Card Number:</mat-label>
              <input matInput placeholder="Card Number" formControlName="cardNumber">
            </mat-form-field>
          </div>

          <div class="col-6">
            <mat-form-field appearance="fill" style="width:100%;color:gray">
              <mat-label>Delivery Method:</mat-label>
              <mat-select formControlName="invoiceDeliveryMethod">
                <mat-option value="ALL">All</mat-option>
                <mat-option value="Email">Email</mat-option>
                <mat-option value="Print">Print</mat-option>
              </mat-select>
            </mat-form-field>          
          </div>
          
  
          <div class="col-6">
            <mat-form-field appearance="fill" style="width:100%;color:gray">
              <mat-label>Rate Type:</mat-label>
              <mat-select matNativeControl formControlName="rateNumber">
                <mat-option value="0">Select Rate</mat-option>
                <mat-option *ngFor="let rate of marketRateList" [value]="rate.rateNumber.toString()" >
                  ({{rate.rateType}})  {{rate.activeRate | currency }} - {{rate.description}}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
  
          <div class="col-6">
            <mat-form-field appearance="fill" style="width:100%;color:gray">
              <mat-label>Parker Pay Type:</mat-label>
              <select matNativeControl formControlName="parkerPayType">
                <option value="ALL">All Pay Types</option>
                <option value="Parker">Parker</option>
                <option value="Company">Company</option>
              </select>
            </mat-form-field>
           
          </div>
  
          <div class="col-6">
            <mat-form-field appearance="fill" style="width:100%">
              <mat-label>Parker ID:</mat-label>
              <input matInput placeholder="Parker ID"  formControlName="parkerId">
            </mat-form-field>
          </div>

          <div class="col-6">
            <mat-form-field appearance="fill" style="width:100%">
              <mat-label>Primary or Space Email Address:</mat-label>
              <input matInput placeholder="Primary or Space Email Address" formControlName="emailAddress">
            </mat-form-field>
          </div>
        </div>

        <div class="col-12" style="margin-top:10px;">
          <input class="form-check-input" type="checkbox" value="" id="isPortalUser" formControlName="isPortalUser" >
          <label class="ace-standard-checkbox" for="isPortalUser" style="margin-left:5px;">
            Is Portal User Only?
          </label>

          <input class="form-check-input" type="checkbox" value="" id="isAutoPay" style="margin-left:25px;" formControlName="isAutoPay">
          <label class="ace-standard-checkbox" for="isAutoPay" style="margin-left:5px">
            Is Auto Pay Only?
          </label>

          <input class="form-check-input" type="checkbox" value="" id="commentsOnly" style="margin-left:25px;"formControlName="commentsOnly">
          <label class="ace-standard-checkbox" for="commentsOnly" style="margin-left:5px;">
            Comments Only
          </label>

          <input class="form-check-input" type="checkbox" value="" id="includeInactive" style="margin-left:25px;" formControlName="includeInactive">
          <label class="ace-standard-checkbox" for="includeInactive" style="margin-left:5px;">
            Show Inactive Parkers
          </label>
        </div>


        <!-- End Accordian Expansion Panel -->
            
        <div *ngIf="LotListByUserName.length > 0">
          <button type="submit" class="btn btn-primary mt-3 ace-blue" style="margin-left:20px;"  [disabled]="disableSearchButton || queryCriteriaForm.invalid">Search</button>
          <button type="button" class="btn btn-light mt-3" style="margin-left:5px;" (click)="resetParkerSearchCriteria()"  >Clear</button>
        </div>

      </form>
    
        <div class="form-check mt-2" style="margin-left:20px;font-size:12px;">
          <input class="form-check-input" type="checkbox" value="" id="flexCheckChecked" [(ngModel)]="hideSearchCriteria">
          <label class="form-check-label" for="flexCheckChecked">
            Hide Parker Criteria on Search
          </label>
          </div>

         
        
          </mat-expansion-panel>
       
        </mat-accordion>
      
        <div class="row  mt-3" style="margin-left:0px;margin-right:10px;">
          
        
      </div>

      <div class="row mt-3">
       
      </div>

     
      
  </div>
 </div>
 </div>
 </div>
  
</div>




